module.exports = __webpack_public_path__ + "img/skill-8.04ba8b79.svg";